import { GetDeployResult, NetworkMajorVersion } from '@block-explorer/entities';
import {
  ExecutionResult,
  InfoGetDeployResultV1Compatible,
  InfoGetTransactionResultV1Compatible,
} from 'casper-js-sdk';
import { useGetCasperNetwork } from '../casper-network-context.tsx';

// TODO: I see that we are using this hook is more like helper function, so we can rename it
// to getExecutionResultsFromDeployRawData and move to utils instead of hook
export const useGetExecutionResultsFromDeployRawData = (
  deployRawData?: GetDeployResult
): ExecutionResult | null => {
  if (!deployRawData) return null;
  const networkVersionFromRawData =
    (deployRawData.api_version && deployRawData.api_version.startsWith('1')
      ? NetworkMajorVersion.V1
      : NetworkMajorVersion.V2) || NetworkMajorVersion.V2;

  if (networkVersionFromRawData === '1') {
    const transactionData =
      InfoGetDeployResultV1Compatible.fromJSON(deployRawData);

    return transactionData?.executionResults &&
      transactionData?.executionResults[0]
      ? ExecutionResult.fromV1(transactionData.executionResults?.[0].result)
      : null;
  }

  const transactionData =
    InfoGetTransactionResultV1Compatible.fromJSON(deployRawData);

  return transactionData?.executionInfo
    ? transactionData.executionInfo.executionResult
    : null;
};
